import { TokenETH, TokenUSDC, TokenUSDT } from '@web3icons/react'

/**
 * Официальные глифы из @web3icons/react — brand-accurate SVG-пути, встроены
 * в бандл при сборке, никаких внешних запросов (CSP на выкатке их запрещает).
 * У пакета нет отдельного значка для WETH — берём ромб ETH и добавляем своё
 * кольцо: это разные активы, у них разный maxLTV и обёртка стоит транзакции.
 */
export type TokenSymbol = 'USDT' | 'USDC' | 'WETH' | 'ETH'

const LABEL: Record<TokenSymbol, string> = {
  USDT: 'Tether USD',
  USDC: 'USD Coin',
  WETH: 'Wrapped Ethereum',
  ETH: 'Ethereum',
}

export function tokenName(sym: TokenSymbol): string {
  return LABEL[sym]
}

const BG: Record<TokenSymbol, string> = {
  USDT: '#009393',
  USDC: '#0B53BF',
  WETH: '#1C1C1E',
  ETH: '#627EEA',
}

const GLYPH: Record<TokenSymbol, typeof TokenETH> = {
  USDT: TokenUSDT,
  USDC: TokenUSDC,
  WETH: TokenETH,
  ETH: TokenETH,
}

export function TokenIcon({ symbol, size = 22 }: { symbol: TokenSymbol; size?: number }) {
  const Glyph = GLYPH[symbol]
  return (
    <span
      style={{
        width: size,
        height: size,
        boxSizing: 'border-box',
        borderRadius: '50%',
        background: BG[symbol],
        border: symbol === 'WETH' ? `1.5px solid ${BG.ETH}` : undefined,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '0 0 auto',
      }}
      aria-hidden
    >
      <Glyph variant="mono" color="#fff" size={Math.round(size * 0.6)} />
    </span>
  )
}
